import { useQuery } from '@hooks/reactQuery';

import { getDashboardAssetTypesSummaryPerOrganizations } from '@api/dashboardPO';

import { extractQueryParams } from '@utils/common';

import { TDashboardAssetTypeSummaryPerOrganizationDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_ASSET_TYPES_SUMMARY_PER_ORGANIZATION } from '@constants/queryKeys';

const useQueryDashboardAssetTypesSummaryPerOrganization = (params: TDashboardAssetTypeSummaryPerOrganizationDTO) => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [
			DASHBOARD_ASSET_TYPES_SUMMARY_PER_ORGANIZATION,
			params,
		],
		queryFn: extractQueryParams(getDashboardAssetTypesSummaryPerOrganizations),
		enabled: [!!params?.id],
		...refetchOptions,
	});

	return {
		countOfRecords: data?.count || 0,
		dashboardAssetTypesPerOrganizationsSummary: data?.items || [],
		isLoadingDashboardAssetTypesPerOrganizationsSummary: (isLoading && !!data) || isFetching,
	};
};

export default useQueryDashboardAssetTypesSummaryPerOrganization;

